import {useEffect, useState} from "react";
import {useLocation, useParams} from "react-router-dom";

import {useConfigModule} from "base/ui/module/provider";
import {LocationProvider} from "snimf/location/provider";
import {PermitApplicationService} from "permitapplication/service";

import {PageLayout} from "base/ui/main";
import {PermitApplicationSubPageMenu} from "permitapplication/menu";
import {useErrors} from "base/error/provider";

const ViewPermitApplicationPage = () => {
    const {id} = useParams();
    const {handleErrors} = useErrors();

    const [permit, setPermit] = useState(null);
    const location = useLocation();

    const {setModuleBasePath, isLoading, setIsLoading} = useConfigModule();

    useEffect(() => {
        setIsLoading(true);
        setPermit(null);
        setModuleBasePath(`/applications/list/${id}`);
        PermitApplicationService.get(id)
            .then(data => {
                setPermit(data);
            })
            .catch(error => {
                handleErrors(error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [id, location.state?.lastRefreshDate]);

    return (
        <LocationProvider>
            <PageLayout
                menu={<PermitApplicationSubPageMenu permit={permit} />}
                context={[permit]}
                isLoading={isLoading}
                subPage
            />
        </LocationProvider>
    );
};

export default ViewPermitApplicationPage;
